// import { METHOD_AXIOS } from '../utils/constant'
import { BaseApi } from './base.api'
import { DEFAULT_PAGE_SIZE } from '../utils/constant'

export class ReportApi extends BaseApi {
	constructor() {
		super('')
	}

	async getAllReport(page, params = {}) {
		const searchParams = new URLSearchParams({
			pageNum: String(page),
			pageSize: String(params.pageSize ?? DEFAULT_PAGE_SIZE),
		})
		if (params.rating) {
			searchParams.set('rating', params.rating)
		}
		if (params.createdAtFrom) {
			searchParams.set('createdAtFrom', params.createdAtFrom)
		}
		if (params.createdAtTo) {
			searchParams.set('createdAtTo', params.createdAtTo)
		}
		if (params.wordLang === 'en' || params.wordLang === 'vi') {
			searchParams.set('wordLang', params.wordLang)
		}
		const rs = await this.get(`api/feedback/report?${searchParams}`)
		return rs
	}

	/** Pie chart stats: by word-column language; missing = open no_definition, added = report + resolved no_definition. */
	async getReportStats(params = {}) {
		const searchParams = new URLSearchParams()
		if (params.createdAtFrom) {
			searchParams.set('createdAtFrom', params.createdAtFrom)
		}
		if (params.createdAtTo) {
			searchParams.set('createdAtTo', params.createdAtTo)
		}
		const q = searchParams.toString()
		const path = q
			? `api/feedback/report/stats?${q}`
			: 'api/feedback/report/stats'
		const rs = await this.get(path)
		return rs
	}

	/** Mark a word report resolved and notify the reporter (in-app notification). Admin only. Optional email to reporter. */
	async resolveReport(feedbackID, message, sendEmail = false) {
		return this.post('api/feedback/report/resolve', {
			feedbackID,
			message,
			sendEmail,
		})
	}
}
